import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';
import { ConfiguracionModulo } from '../../../components/hacienda/actividadEconomica/modalConfiguracionModulo';
import { ImpSectorLicores } from './modalImprimirLicores';
import { ImpLicenciasLicores } from './modalImpLicencias';


function MenuLicores(props) {

    const { user, logout } = useContext(AuthContext);
    const pathname = window.location.pathname;

    const path = pathname === '/' ? 'login' : pathname.substr(1);
    const [activeItem, setActiveItem] = useState(path);
    const [permisos, setPermisos] = useState('');
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrar6, setMostrar6] = useState(false);
    const [mostrar7, setMostrar7] = useState(false);
    const [mostrarClasificador, setMostrarClasificador] = useState(false);
    const [mostrarEstados, setMostrarEstados] = useState(false);
    const [titulo1, setTitulo1] = useState();
    const [titulo2, setTitulo2] = useState();
    const [tipoRep, setTipoRep] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));


    let op = require('../../../../src/modulos/datos');

    useEffect(() => {

        setPermisos(JSON.parse(localStorage.getItem('permisos')));
        let obj = JSON.parse(localStorage.getItem('post'));
        setIdUsuario(obj.idusuario);
        //setEspiritu(obj.espiritu);
        /*setLiquidador(obj.liquidador);
        setLiquida(obj.liquida);*/
        setFechaSistema(obj.fechasistema);
        setEspiritu(obj.espiritu);

    }, [props.permisos]);


    const handleItemClick = (e, { name }) => setActiveItem(name);


    const handleCancelaImpSector = () => {
        /* window.location.href = '/JuegosApuestas'; */
        setMostrar3(false);

    }

    const imprimerSitucacion = (reporte) => (event) => {
        event.preventDefault();

        window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }


    const handleImpSector = (tiprep) => (event) => {
        setTipoRep(tiprep)

        if (tiprep === '1') {
            setTitulo1('ImpresionGeneral de Contribuyentes de Rentas Licores por Sector');
            setTitulo2('Listado General de Contribuyentes Por Sector');
        }

        else if (tiprep === '2') {
            setTitulo1('Declarraciones Anuales de Contribuyentes de Rentas Licores con Deudas');
            setTitulo2('Declaraciones Anuales de Contribuyentes Apuestas Licitas');
        }

        setMostrar3(true)
    }

    const abrirConfiModulo = () => {
        setMostrar7(true)
    }

    const handleCancelaConfi = () => {
        setMostrar7(false)
    }

    const handleCancelaLic = () => {
        setMostrar5(false)
    }

    const handleOpenLic = () => {
        setMostrar5(true)
    }



    const menu =  ''


    return menu;

} export default MenuLicores;